import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
var NumberUtils = /** @class */ (function () {
    function NumberUtils() {
        this.uomLists = { Thousand: { shortname: 'K' }, Million: { shortname: 'M' }, Billion: { shortname: 'B' }, Trillion: { shortname: 'T' } };
        // try {
        //   this.properties = { BI_BASE_URL: '/bi', EPMS_BASE_URL: '/home' };
        //   this.getUom().then(function (success: any) {
        //   });
        // } catch (e) {
        //   console.error(e);
        // }
    }
    Object.defineProperty(NumberUtils, "MILLION", {
        get: function () { return 1000000.0; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NumberUtils, "BILLION", {
        get: function () { return 1000000000.0; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NumberUtils, "LAKHS", {
        get: function () { return 100000.0; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NumberUtils, "THOUSANDS", {
        get: function () { return 1000.0; },
        enumerable: true,
        configurable: true
    });
    ;
    NumberUtils.prototype.autoScale = function (value) {
        var suffix = '';
        try {
            var x = parseFloat(value);
            var opr = x > 0 ? 1 : -1;
            x = Math.abs(x);
            if (x > NumberUtils.BILLION) {
                value = x / (NumberUtils.BILLION);
                suffix = this.uomLists.Billion.shortname;
            }
            else if (x > NumberUtils.MILLION) {
                value = x / (NumberUtils.MILLION);
                suffix = this.uomLists.Million.shortname;
            }
            else if (x > NumberUtils.LAKHS) {
                value = x / (NumberUtils.THOUSANDS);
                suffix = this.uomLists.Thousand.shortname;
            }
            value = opr == -1 ? -Math.abs(value) : value;
        }
        catch (e) { }
        return { value: value, suffix: suffix };
    };
    NumberUtils.prototype.autoFormat = function (x, cft) {
        try {
            var val = this.autoScale(x);
            return this.numberWithCommas(val.value, cft) + " " + val.suffix;
        }
        catch (e) {
            return '';
        }
    };
    NumberUtils.prototype.numberWithCommas = function (val, format) {
        try {
            if (!Number.isNaN(val)) {
                var x = Math.round(val * 100) / 100;
                var parts = void 0;
                if (format) {
                    parts = x.toFixed(format.pre).split(".");
                }
                else {
                    parts = x.toString().split(".");
                }
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return parts.join(".");
            }
        }
        catch (e) {
        }
        return 0;
    };
    NumberUtils.prototype.isNaN = function (obj) {
        try {
            return isNaN(Number(obj));
        }
        catch (e) {
            return true;
        }
    };
    NumberUtils.prototype.checkDecimalPoints = function (event, dp) {
        var val = event.target.value.trim();
        var dec = val.split('.');
        var decimals = "";
        if (!(/^[-]?[0-9]+(?:\.[0-9]*)?$/.test(val))) {
            event.target.value = val.slice(0, -1);
            return;
        }
        else {
            if (dec.length > 1) {
                decimals = dec[1];
            }
            else {
                return;
            }
            if (val != "" && (decimals && decimals.length > dp)) {
                //console.log("Initial ", val);
                var f = parseFloat(val);
                var np = f.toFixed(dp);
                event.target.value = np;
                //console.log("Changed ", event.target.value);
            }
        }
    };
    Object.defineProperty(NumberUtils.prototype, "symbols", {
        get: function () {
            var self = this;
            try {
                var symbols = [];
                if (self.uomLists.Thousand.shortname) {
                    symbols.push(' ' + self.uomLists.Thousand.shortname.charAt(0));
                }
                else {
                    symbols.push(' k');
                }
                if (self.uomLists.Million.shortname) {
                    symbols.push(' ' + self.uomLists.Million.shortname.charAt(0));
                }
                else {
                    symbols.push(' M');
                }
                if (self.uomLists.Billion.shortname) {
                    symbols.push(' ' + self.uomLists.Billion.shortname.charAt(0));
                }
                else {
                    symbols.push(' B');
                }
                if (self.uomLists.Trillion.shortname) {
                    symbols.push(' ' + self.uomLists.Trillion.shortname.charAt(0));
                }
                else {
                    symbols.push(' T');
                }
                return symbols;
            }
            catch (e) {
                return ["k", "M", "G", "T", "P", "E"];
            }
        },
        enumerable: true,
        configurable: true
    });
    NumberUtils.prototype.get = function (key) {
        return this.properties && this.properties[key] ? this.properties[key] : undefined;
    };
    NumberUtils.prototype.getUom = function () {
        var self = this;
        //if (this.uomLists) {
        return new Promise(function (observer, reject) {
            observer(self.uomLists);
        });
        //}
        // } else {
        //     return new Promise((observer, reject: any) => {
        //         let url: string;
        //         let https: any = [];
        //         url = this.get("BI_BASE_URL") + '/v1/ads/value_range';
        //         //console.log(url)
        //         this._httpClient.get(url).subscribe(res => {
        //             self.uomLists = res;
        //             observer(res);
        //         }, err => {
        //             //console.log(err);
        //             reject(err);
        //         });
        //     });
        // }
    };
    return NumberUtils;
}());
export { NumberUtils };



// WEBPACK FOOTER //
// ./src/app/bi/common/service/number.utils.ts.pre-build-optimizer.js